import widgetRenderer from '../utils/widget-render';
import { WidgetInfo } from '../utils/widget-constants';

export default function vfLivestory(
    widgetInfo: WidgetInfo,
    observer: IntersectionObserver,
): void {
    widgetRenderer(widgetInfo, observer);
}
